module.exports = __webpack_public_path__ + "img/zxdt-bj.11d1cefa.png";